import {personColor, tintClasses} from '@/utils/colors'

/**
 * A cara de uma pessoa quando não é a foto: as iniciais sobre a cor dela. Um dono para os dois que a
 * desenham — o `UserAvatar`, em toda tela, e a referência a uma pessoa no markdown (ver
 * `markdownMentionView`), que é HTML e não componente. Na referência só a foto saía, e quem não tem foto
 * ficava sem a bolinha (relato do usuário).
 *
 * **A cor vem do id da conta** (`personColor`): derivada, nunca gravada, a mesma em toda tela. O fundo
 * claro e o texto escuro da mesma cor (`tintClasses`): o par do chip de uma opção.
 */
export function personAvatar(user: number, label: string): { initials: string, classes: string[] } {
    return {initials: initialsOf(label), classes: tintClasses(personColor(user))}
}

/**
 * A primeira e a última inicial do rótulo.
 *
 * `\p{L}` com a flag `u` em vez de `[A-Za-z]`: nome com acento, cedilha ou alfabeto não latino também
 * tem inicial. Com uma palavra só, `shift` e `pop` pegam o mesmo par e sai uma letra.
 */
function initialsOf(label: string): string {
    const matches = [...label.matchAll(/(\p{L})\p{L}*/gu)]
    return ((matches.shift()?.[1] || '') + (matches.pop()?.[1] || '')).toUpperCase()
}
